import Vue from 'vue'
import events from '../events'

Vue.prototype.$events = events
